import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthTransactionAction, CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { DeviceConfigService } from "@obg/ngx.global";

import { SgaLoginUiFlowService } from "../../sga-login-flow.service";
import { SGA_VERIFICATION_TRANSACTION_PREFIX } from "../../sga-login.const";
import { BusyMessage, SgaLoginData } from "../../sga-login.model";

@Component({
	selector: "obg-m-verification-sga-login-with-dialog",
	templateUrl: "./verification-login-with-dialog.container.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [SgaLoginUiFlowService],
})
export class VerificationSgaLoginWithDialogContainer {
	readonly translationPrefix = SGA_VERIFICATION_TRANSACTION_PREFIX;
	readonly dialogId = CORE_ROUTE.auth.bankIdVerification;
	readonly isDesktop: boolean;
	description = `${this.translationPrefix}.description`;

	@Output() busy = new EventEmitter<BusyMessage>();

	constructor(
		private store: Store<CoreState>,
		private authTransactionAction: AuthTransactionAction,
		deviceConfigService: DeviceConfigService
	) {
		this.isDesktop = deviceConfigService.isDesktop();
	}

	login(data: SgaLoginData) {
		this.store.dispatch(
			this.authTransactionAction.initializeVerification({
				personalNumber: data.personalNumberForm.controls.personalNumber.value,
				token: data.loginToken,
			})
		);
	}
}
